import React, { useState, useEffect } from 'react';
import { Checkbox } from '@superops/ui-design-system';
import { cloneDeep, isString } from 'lodash';

function CheckboxField(props) {
  const { label } = props.attribute;

  const { options } = props;

  const [value, setValue] = useState([]);

  useEffect(() => {
    if (!props.value) {
      setValue(value);
      return;
    }
    if (Array.isArray(props.value)) {
      setValue(props.value);
      return;
    }
    if (isString(props.value)) {
      const checkBoxValues = props.value.split(',').map((o) => {
        return o.trim();
      });
      setValue(checkBoxValues);
    }
  }, [props.value]);

  const handleChange = (checked, newValue) => {
    const allValues = cloneDeep(value);
    if (!checked) {
      const index = allValues.indexOf(newValue);
      allValues.splice(index, 1);
      setValue(allValues);
    } else {
      allValues.push(newValue);
      setValue(allValues);
    }
    props.handleChange(allValues);
  };

  return (
    <div className="px-10p w100 flex col overflow-y-auto">
      <div>{label}</div>
      {options.map((item) => {
        return (
          <Checkbox
            label={item}
            name={`${props.attribute.columnName}-${item}`}
            id={`${props.attribute.columnName}-${item}`}
            checked={value.indexOf(item) > -1}
            onChange={(checked) => {
              handleChange(checked, item);
            }}
          />
        );
      })}
    </div>
  );
}

export default CheckboxField;
